module.exports = __webpack_public_path__ + "img/FW_MoonAndStarBlade.05494475.png";